import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import ReactQuill from 'react-quill'
import Button from '../../common/CustomComponents/Button.js'

class ProductSoretAdd extends React.Component {
  state = {
    shop_type: '',

    item_name_en: '',
    item_desc_en: '',
    item_amount: '',
    item_type: 'ONETIME',
    is_active: true,
    item_name_ar: '',
    is_stock_enable: true,
    item_desc_ar: '',
    stock_limit: '',
    isData: false,
    selectedCategories: [],
    categoryList: [],
    store_item_options: [],

    store_item_catering_options: [],
    store_item_catering_addon_options: [],
    deleted_catering_categories: [],
    deleted_catering_items: [],
    min_persons: '',
    max_persons: '',
    person_price: '',
    sku: '',
    item_for: 'All',
    readOnly: false,
  }

  componentDidMount() {
    this.getStoreDetails()
    const userRole = localStorage.getItem('user_role')
    if (userRole === 'store') {
      this.setState({ readOnly: true })
    }
  }

  getStoreDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/store/get-store-details/${this.props.storeDetail_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success && res?.data?.data?.shop_type) {
          this.setState(
            {
              shop_type: res.data.data.shop_type,
            },
            () => {
              this.ProductStoreList()
              this.getCategories()
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    const { name, value } = event.target
    if (name == 'selectedCategories') {
      if (this.state.selectedCategories.includes(value)) {
        const index = this.state.selectedCategories.indexOf(value)
        if (index > -1) {
          this.state.selectedCategories.splice(index, 1)
        }
      } else {
        this.state.selectedCategories.push(value)
      }
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    this.setState({ img: URL.createObjectURL(e.target.files[0]) })
  }

  getCategories = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/list-item-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const data = res.data?.data
          if (data && data.length) {
            this.setState({
              categoryList: data,
            })
          }
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addProductDetails = async () => {
    var that = this

    if (this.state.stock_limit <= 0) {
      document.getElementById('stock_limit')?.focus()
      that.setState({ isSaving: false })
      Swal.fire({
        title: 'stock limit Must be Greater 0',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }

    for (let item of this.state.store_item_options) {
      if (!item.name_ar || !item.name_en) {
        Swal.fire({
          title: 'Option names are required',
          icon: 'error',
          text: '',
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        return false
      }
    }

    const formData = new FormData()
    formData.append('store_id', this.props.storeDetail_id)
    formData.append('item_name_en', this.state.item_name_en)
    formData.append('item_desc_en', this.state.item_desc_en)
    formData.append('item_amount', this.state.item_amount)
    formData.append('is_stock_enable', this.state.is_stock_enable)
    formData.append('stock_limit', this.state.stock_limit)
    formData.append('item_type', this.state.item_type)
    formData.append('is_active', this.state.is_active)
    formData.append('item_name_ar', this.state.item_name_ar)
    formData.append('item_desc_ar', this.state.item_desc_ar)
    formData.append('selectedCategories', this.state.selectedCategories)
    formData.append('store_item_options', JSON.stringify(this.state.store_item_options))
    formData.append('item_for', this.state.item_for)
    if (this.state.sku) {
      formData.append('sku', this.state.sku)
    }

    if (this.state.shop_type == 'CATERING') {
      formData.append('min_persons', this.state.min_persons)
      formData.append('max_persons', this.state.max_persons)
      formData.append('person_price', this.state.person_price)

      formData.append('store_item_catering_options', JSON.stringify(this.state.store_item_catering_options))
      formData.append('store_item_catering_addon_options', JSON.stringify(this.state.store_item_catering_addon_options))
      formData.append('deleted_catering_categories', JSON.stringify(this.state.deleted_catering_categories))
      formData.append('deleted_catering_items', JSON.stringify(this.state.deleted_catering_items))
    }

    this.setState({ isData: true })

    if (this.props.store_id) {
      formData.append('itemId', this.props.store_id)

      if (this.state.shop_item_img?.name) {
        formData.append('shop_item_img', this.state.shop_item_img)
      }

      await axios
        .post(Constant.getAPI() + '/store/update-store-item', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })

          if (res?.data?.success) {
            Swal.fire({
              title: 'Product Details Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
            window.location.href = `#/store-products/${this.props.storeDetail_id}`
          }
        })
        .catch((err) => {
          that.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      formData.append('shop_item_img', this.state.shop_item_img)

      await axios
        .post(Constant.getAPI() + '/store/create-store-item', formData, {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          Swal.fire({
            title: 'Product Details Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          this.setState({ isData: false })
          window.location.href = `#/store-products/${this.props.storeDetail_id}`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  getCategoryIds = async () => {
    await axios
      .get(Constant.getAPI() + `/store/store-item-categories/${this.props.store_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const data = res.data.data
          this.setState({
            selectedCategories: data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getItemOptions = async () => {
    await axios
      .get(Constant.getAPI() + `/store/store-item-options/${this.props.store_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const data = res.data.data
          this.setState({
            store_item_options: data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  ProductStoreList = async () => {
    await axios
      .get(Constant.getAPI() + `/store/list-products/${this.props.storeDetail_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res?.data?.data?.result.filter((itm) => itm.id === this.props.store_id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
              Edit: true,
            })

            if (this.state.shop_type == 'CATERING') {
              this.getCateringData(itm.id)
            }

            this.getCategoryIds()
            this.getItemOptions()
          } else {
            // this.addItemOption();
          }
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSaveData = () => {
    this.addProductDetails()
  }

  handleItemOptionChange = (event, index) => {
    const { name, value } = event.target
    const dataCopy = [...this.state.store_item_options]
    dataCopy[index][name] = value
    this.setState({
      ...this.state,
      store_item_options: dataCopy,
    })
  }

  handleChangeStoreCategoryItem = (cat_index, item_index, event) => {
    const { name, value } = event.target
    const dataCopy = [...this.state.store_item_catering_options]
    dataCopy[cat_index].items[item_index][name] = value

    this.setState({
      store_item_catering_options: dataCopy,
    })
  }

  handleChangeStoreCategoryAddonItem = (cat_index, item_index, event) => {
    const { name, value } = event.target
    const dataCopy = [...this.state.store_item_catering_addon_options]
    dataCopy[cat_index].items[item_index][name] = value

    this.setState({
      store_item_catering_addon_options: dataCopy,
    })
  }

  handleChangeStoreCategory = (index, event) => {
    const { name, value } = event.target
    const dataCopy = [...this.state.store_item_catering_options]
    dataCopy[index][name] = value

    this.setState({
      store_item_catering_options: dataCopy,
    })
  }

  handleChangeStoreAddonCategory = (index, event) => {
    const { name, value } = event.target
    const dataCopy = [...this.state.store_item_catering_addon_options]
    dataCopy[index][name] = value

    this.setState({
      store_item_catering_addon_options: dataCopy,
    })
  }

  addCateringOption = () => {
    this.setState({
      store_item_catering_options: [
        ...this.state.store_item_catering_options,
        {
          name_en: '',
          name_ar: '',
          max_items: 1,
          order: 1,
          is_addon: false,
          items: [],
        },
      ],
    })
  }

  addCateringAddonOption = () => {
    this.setState({
      store_item_catering_addon_options: [
        ...this.state.store_item_catering_addon_options,
        {
          name_en: '',
          name_ar: '',
          max_items: 1,
          order: 1,
          is_addon: true,
          items: [],
        },
      ],
    })
  }

  addFoodItem = (i) => {
    let item = this.state.store_item_catering_options

    item[i].items.push({
      name_en: '',
      name_ar: '',
      desc_en: '',
      desc_ar: '',
      selection: 'single',
      price: 0,
      order: 1,
    })

    this.setState({
      store_item_catering_options: item,
    })
  }

  addAddonFoodItem = (i) => {
    let item = this.state.store_item_catering_addon_options

    item[i].items.push({
      name_en: '',
      name_ar: '',
      desc_en: '',
      desc_ar: '',
      selection: 'single',
      order: 1,
      price: 0,
    })

    this.setState({
      store_item_catering_addon_options: item,
    })
  }

  removeFoodItem = (category_index, item_index) => {
    this.state.deleted_catering_items.push(this.state.store_item_catering_options[category_index].items[item_index].id)
    let item = [...this.state.store_item_catering_options]

    item[category_index].items.splice(item_index, 1)

    this.setState({
      store_item_catering_options: item,
    })
  }

  removeAddonFoodItem = (category_index, item_index) => {
    this.state.deleted_catering_items.push(
      this.state.store_item_catering_addon_options[category_index].items[item_index].id
    )
    let item = [...this.state.store_item_catering_addon_options]

    item[category_index].items.splice(item_index, 1)

    this.setState({
      store_item_catering_addon_options: item,
    })
  }

  removeCateringOption = (i) => {
    this.state.deleted_catering_categories.push(this.state.store_item_catering_options[i].id)
    let items = [...this.state.store_item_catering_options]
    items.splice(i, 1)

    this.setState({
      store_item_catering_options: items,
    })
  }

  removeCateringAddonOption = (i) => {
    this.state.deleted_catering_categories.push(this.state.store_item_catering_addon_options[i].id)
    let items = [...this.state.store_item_catering_addon_options]
    items.splice(i, 1)

    this.setState({
      store_item_catering_addon_options: items,
    })
  }

  addItemOption = () => {
    const newEntry = {
      name_en: '',
      name_ar: '',
      is_stock_enable: 0,
      stock_limit: 0,
      price: 0,
    }
    const dataCopy = [...this.state.store_item_options, newEntry]

    this.setState({
      ...this.state,
      store_item_options: dataCopy,
    })
  }

  removeItemOption = (index) => {
    const dataCopy = [...this.state.store_item_options]

    dataCopy.splice(index, 1)

    this.setState({
      ...this.state,
      store_item_options: dataCopy,
    })
  }

  getCateringData = async (id) => {
    await axios
      .get(Constant.getAPI() + `/store/catering-category-list/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const data = res.data.data
          this.setState({
            store_item_catering_options: data.categories,
            store_item_catering_addon_options: data.addonCategories,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row m-b-20">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Item Name : English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="item_name_en"
                    id="item_name_en"
                    placeholder="Item Name : English"
                    onChange={this.handleChange}
                    value={this.state.item_name_en}
                    readOnly={this.state.readOnly}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Item Name : Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="item_name_ar"
                    id="item_name_ar"
                    placeholder="Item Name : Arabic"
                    onChange={this.handleChange}
                    value={this.state.item_name_ar}
                    readOnly={this.state.readOnly}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: En</label>
                <div className="col-sm-9">
                  {/* <input
                                        type="text"
                                        className="form-control"
                                        name="item_desc_en"
                                        id="item_desc_en"
                                        placeholder="Description : Arabic"
                                        onChange={this.handleChange}
                                        value={this.state.item_desc_en}
                                    /> */}
                  <ReactQuill
                    placeholder="Description: En"
                    name="item_desc_en"
                    id="item_desc_en"
                    value={this.state.item_desc_en}
                    onChange={(value) => {
                      this.setState({
                        item_desc_en: value,
                      })
                    }}
                    readOnly={this.state.readOnly}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: Ar</label>
                <div className="col-sm-9">
                  {/* <input
                                        type="text"
                                        className="form-control"
                                        name="item_desc_ar"
                                        id="item_desc_ar"
                                        placeholder="Item Name : Arabic"
                                        onChange={this.handleChange}
                                        value={this.state.item_desc_ar}
                                    /> */}
                  <ReactQuill
                    placeholder="Item Name: Ar"
                    name="item_desc_ar"
                    id="item_desc_ar"
                    value={this.state.item_desc_ar}
                    onChange={(value) => {
                      this.setState({
                        item_desc_ar: value,
                      })
                    }}
                    readOnly={this.state.readOnly}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Stock limit</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="stock_limit"
                    id="stock_limit"
                    placeholder="stock limit greater than 0"
                    onChange={this.handleChange}
                    value={this.state.stock_limit}
                    readOnly={this.state.readOnly}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Item Amount</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="item_amount"
                    id="item_amount"
                    placeholder="Item Amount"
                    onChange={this.handleChange}
                    value={this.state.item_amount}
                    readOnly={this.state.readOnly}
                  />
                </div>
              </div>
            </div>
            {this.state.shop_type === 'CATERING' && (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Min Persons</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="min_persons"
                        id="min_persons"
                        placeholder="Min Persons"
                        onChange={this.handleChange}
                        value={this.state.min_persons}
                        readOnly={this.state.readOnly}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Max Persons</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="max_persons"
                        id="max_persons"
                        placeholder="Max Persons"
                        onChange={this.handleChange}
                        value={this.state.max_persons}
                        readOnly={this.state.readOnly}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Person Price</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="person_price"
                        id="person_price"
                        placeholder="Per Person Price"
                        onChange={this.handleChange}
                        value={this.state.person_price}
                        readOnly={this.state.readOnly}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6"></div>
              </>
            )}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Item type</label>
                <div className="col-sm-9">
                  <select
                    name="item_type"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.item_type}
                    readOnly={this.state.readOnly}
                  >
                    <option value="ONETIME">OneTime</option>
                    <option value="HOUR"> Hour </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Stock Enable</label>
                <div className="col-sm-9">
                  <select
                    name="is_stock_enable"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.is_stock_enable}
                    readOnly={this.state.readOnly}
                  >
                    <option value="true">Yes</option>
                    <option value="false"> No </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Categories</label>
                <div className="col-sm-9">
                  <select
                    name="selectedCategories"
                    className="form-control"
                    multiple
                    onChange={this.handleChange}
                    value={this.state.selectedCategories}
                    readOnly={this.state.readOnly}
                  >
                    <option>Select categories</option>
                    {this.state.categoryList.map((item) => (
                      <option
                        value={item.id}
                        key={item.id}
                      >
                        {item.nameEn}
                        {' / '}
                        {item?.nameAr}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                    readOnly={this.state.readOnly}
                  >
                    <option
                      value="true"
                      name="is_active"
                    >
                      Active
                    </option>
                    <option
                      value="false"
                      name="is_active"
                    >
                      InActive
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">SKU</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="sku"
                    id="sku"
                    placeholder="Stock Keeping Unit"
                    onChange={this.handleChange}
                    value={this.state.sku}
                    readOnly={this.state.readOnly}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Item For</label>
                <div className="col-sm-9">
                  <select
                    name="item_for"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.item_for}
                    disabled={this.state.readOnly}
                  >
                    <option value="All">All</option>
                    <option value="Cruise">Cruise</option>
                    <option value="Chalet">Chalet</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3"> Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        disabled={this.state.readOnly}
                        type="file"
                        id="img"
                        name="shop_item_img"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                  </div>
                  {this.state.Edit ? (
                    <img
                      width="250px"
                      height="200px"
                      src={Constant.getImage() + this.state.shop_item_img}
                      alt="img"
                    />
                  ) : (
                    <img
                      width="250px"
                      height="200px"
                      src={this.state.img}
                      alt="img"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {this.state.shop_type == 'CATERING' ? (
            <>
              <div className="card border">
                <div
                  className="card-header"
                  style={{ paddingTop: 15, paddingBottom: 15 }}
                >
                  <h3 className="float-left card-title">Add food Option Categories</h3>
                  <span className="float-right m-0">
                    <button
                      disabled={this.state.readOnly}
                      className="btn btn-primary btn-sm"
                      onClick={this.addCateringOption}
                    >
                      Add More
                    </button>
                  </span>
                </div>
                {this.state.store_item_catering_options.length > 0 && (
                  <div className="card-body">
                    {this.state.store_item_catering_options.map((item, category_index) => (
                      <div
                        className="card border m-0"
                        style={{ background: '#ffe' }}
                        key={category_index}
                      >
                        <div
                          className="card-header"
                          style={{ padding: 20, borderBottom: '1px solid #ddd' }}
                        >
                          <h5 className="float-left card-title">Category {category_index + 1}#</h5>
                          <span className="float-right m-l-10">
                            <button
                              disabled={this.state.readOnly}
                              className="btn"
                              style={{ padding: 5 }}
                              onClick={() => this.removeCateringOption(category_index)}
                            >
                              <i className="icofont icofont-close text-danger f-20"></i>
                            </button>
                          </span>
                          <span className="float-right">
                            <button
                              disabled={this.state.readOnly}
                              className="btn"
                              style={{ padding: 5 }}
                              onClick={() => this.addFoodItem(category_index)}
                            >
                              Add Food Item
                            </button>
                          </span>
                        </div>
                        <div className="card-body row">
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Name in English</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name_en"
                                  placeholder="Name in English"
                                  value={item.name_en}
                                  onChange={this.handleChangeStoreCategory.bind(this, category_index)}
                                  readOnly={this.state.readOnly}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Name in Arabic</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name_ar"
                                  placeholder="Name in English"
                                  value={item.name_ar}
                                  onChange={this.handleChangeStoreCategory.bind(this, category_index)}
                                  readOnly={this.state.readOnly}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Max Items</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="max_items"
                                  placeholder="Enter Number"
                                  value={item.max_items}
                                  onChange={this.handleChangeStoreCategory.bind(this, category_index)}
                                  readOnly={this.state.readOnly}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Order</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="order"
                                  placeholder="Enter Number"
                                  value={item.order}
                                  onChange={this.handleChangeStoreCategory.bind(this, category_index)}
                                  readOnly={this.state.readOnly}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            {item.items.map((foodItem, i) => (
                              <div className="card border m-0">
                                <div
                                  className="card-header"
                                  style={{ padding: 20, borderBottom: '1px solid #ddd' }}
                                >
                                  <h5 className="float-left card-title">Food Item {i + 1}#</h5>
                                  <span className="float-right m-l-10">
                                    <button
                                      disabled={this.state.readOnly}
                                      className="btn"
                                      style={{ padding: 5 }}
                                      onClick={() => this.removeFoodItem(category_index, i)}
                                    >
                                      <i className="icofont icofont-close text-danger f-20"></i>
                                    </button>
                                  </span>
                                </div>
                                <div className="card-body row">
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Name in English</label>
                                      <div className="col-sm-9">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="name_en"
                                          placeholder="Name in English"
                                          value={foodItem.name_en}
                                          onChange={this.handleChangeStoreCategoryItem.bind(this, category_index, i)}
                                          readOnly={this.state.readOnly}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Name in Arabic</label>
                                      <div className="col-sm-9">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="name_ar"
                                          placeholder="Name in English"
                                          value={foodItem.name_ar}
                                          onChange={this.handleChangeStoreCategoryItem.bind(this, category_index, i)}
                                          readOnly={this.state.readOnly}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Description in English</label>
                                      <div className="col-sm-9">
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          name="desc_en"
                                          maxLength={100}
                                          placeholder="Description in English"
                                          value={foodItem.desc_en}
                                          onChange={this.handleChangeStoreCategoryItem.bind(this, category_index, i)}
                                          readOnly={this.state.readOnly}
                                        />
                                      </div>
                                      <div className="col-sm-12 text-right">
                                        {(foodItem?.desc_en?.length || 0) + ' / 100'}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Description in Arabic</label>
                                      <div className="col-sm-9">
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          name="desc_ar"
                                          maxLength={100}
                                          placeholder="Description in Arabic"
                                          value={foodItem.desc_ar}
                                          onChange={this.handleChangeStoreCategoryItem.bind(this, category_index, i)}
                                          readOnly={this.state.readOnly}
                                        />
                                      </div>
                                      <div className="col-sm-12 text-right">
                                        {(foodItem?.desc_ar?.length || 0) + ' / 100'}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Selection</label>
                                      <div className="col-sm-9">
                                        <select
                                          name="selection"
                                          className="form-control"
                                          onChange={this.handleChangeStoreCategoryItem.bind(this, category_index, i)}
                                          value={foodItem.selection}
                                          readOnly={this.state.readOnly}
                                        >
                                          <option value="single">Single</option>
                                          <option value="multiple">Multiple</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Price</label>
                                      <div className="col-sm-9">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="price"
                                          id="price"
                                          placeholder="Price"
                                          onChange={this.handleChangeStoreCategoryItem.bind(this, category_index, i)}
                                          value={foodItem.price}
                                          readOnly={this.state.readOnly}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Order</label>
                                      <div className="col-sm-9">
                                        <input
                                          type="number"
                                          className="form-control"
                                          name="order"
                                          placeholder="Enter Number"
                                          value={foodItem.order}
                                          onChange={this.handleChangeStoreCategoryItem.bind(this, category_index, i)}
                                          readOnly={this.state.readOnly}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="card border">
                <div
                  className="card-header"
                  style={{ paddingTop: 15, paddingBottom: 15 }}
                >
                  <h3 className="float-left card-title">Add Addons Option Categories</h3>
                  <span className="float-right m-0">
                    <button
                      disabled={this.state.readOnly}
                      className="btn btn-primary btn-sm"
                      onClick={this.addCateringAddonOption}
                    >
                      Add More
                    </button>
                  </span>
                </div>
                {this.state.store_item_catering_addon_options.length > 0 && (
                  <div className="card-body">
                    {this.state.store_item_catering_addon_options.map((item, category_index) => (
                      <div
                        className="card border m-0"
                        style={{ background: '#ffe' }}
                        key={category_index}
                      >
                        <div
                          className="card-header"
                          style={{ padding: 20, borderBottom: '1px solid #ddd' }}
                        >
                          <h5 className="float-left card-title">Category {category_index + 1}#</h5>
                          <span className="float-right m-l-10">
                            <button
                              disabled={this.state.readOnly}
                              className="btn"
                              style={{ padding: 5 }}
                              onClick={() => this.removeCateringAddonOption(category_index)}
                            >
                              <i className="icofont icofont-close text-danger f-20"></i>
                            </button>
                          </span>
                          <span className="float-right">
                            <button
                              disabled={this.state.readOnly}
                              className="btn"
                              style={{ padding: 5 }}
                              onClick={() => this.addAddonFoodItem(category_index)}
                            >
                              Add Food Item
                            </button>
                          </span>
                        </div>
                        <div className="card-body row">
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Name in English</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name_en"
                                  placeholder="Name in English"
                                  value={item.name_en}
                                  onChange={this.handleChangeStoreAddonCategory.bind(this, category_index)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Name in Arabic</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name_ar"
                                  placeholder="Name in English"
                                  value={item.name_ar}
                                  onChange={this.handleChangeStoreAddonCategory.bind(this, category_index)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Max Items</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="max_items"
                                  placeholder="Enter Number"
                                  value={item.max_items}
                                  onChange={this.handleChangeStoreAddonCategory.bind(this, category_index)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Order</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="order"
                                  placeholder="Enter Number"
                                  value={item.order}
                                  onChange={this.handleChangeStoreAddonCategory.bind(this, category_index)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            {item.items.map((foodItem, i) => (
                              <div className="card border m-0">
                                <div
                                  className="card-header"
                                  style={{ padding: 20, borderBottom: '1px solid #ddd' }}
                                >
                                  <h5 className="float-left card-title">Food Item {i + 1}#</h5>
                                  <span className="float-right m-l-10">
                                    <button
                                      disabled={this.state.readOnly}
                                      className="btn"
                                      style={{ padding: 5 }}
                                      onClick={() => this.removeAddonFoodItem(category_index, i)}
                                    >
                                      <i className="icofont icofont-close text-danger f-20"></i>
                                    </button>
                                  </span>
                                </div>
                                <div className="card-body row">
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Name in English</label>
                                      <div className="col-sm-9">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="name_en"
                                          placeholder="Name in English"
                                          value={foodItem.name_en}
                                          onChange={this.handleChangeStoreCategoryAddonItem.bind(
                                            this,
                                            category_index,
                                            i
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Name in Arabic</label>
                                      <div className="col-sm-9">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="name_ar"
                                          placeholder="Name in English"
                                          value={foodItem.name_ar}
                                          onChange={this.handleChangeStoreCategoryAddonItem.bind(
                                            this,
                                            category_index,
                                            i
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Description in English</label>
                                      <div className="col-sm-9">
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          name="desc_en"
                                          placeholder="Description in English"
                                          value={foodItem.desc_en}
                                          onChange={this.handleChangeStoreCategoryAddonItem.bind(
                                            this,
                                            category_index,
                                            i
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Description in Arabic</label>
                                      <div className="col-sm-9">
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          name="desc_ar"
                                          placeholder="Description in Arabic"
                                          value={foodItem.desc_ar}
                                          onChange={this.handleChangeStoreCategoryAddonItem.bind(
                                            this,
                                            category_index,
                                            i
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Selection</label>
                                      <div className="col-sm-9">
                                        <select
                                          name="selection"
                                          className="form-control"
                                          onChange={this.handleChangeStoreCategoryAddonItem.bind(
                                            this,
                                            category_index,
                                            i
                                          )}
                                          value={foodItem.selection}
                                        >
                                          <option value="single">Single</option>
                                          <option value="multiple">Multiple</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Price</label>
                                      <div className="col-sm-9">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="price"
                                          placeholder="Enter Price"
                                          value={foodItem.price}
                                          onChange={this.handleChangeStoreCategoryAddonItem.bind(
                                            this,
                                            category_index,
                                            i
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group row">
                                      <label className="col-sm-3 col-form-label">Order</label>
                                      <div className="col-sm-9">
                                        <input
                                          type="number"
                                          className="form-control"
                                          name="order"
                                          placeholder="Enter Number"
                                          value={foodItem.order}
                                          onChange={this.handleChangeStoreCategoryAddonItem.bind(
                                            this,
                                            category_index,
                                            i
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="card border">
              <div
                className="card-header"
                style={{ paddingTop: 15, paddingBottom: 15 }}
              >
                <h3 className="float-left card-title">Add Item Sizes</h3>
                <span className="float-right m-0">
                  <button
                    disabled={this.state.readOnly}
                    className="btn btn-primary btn-sm"
                    onClick={this.addItemOption}
                  >
                    Add More
                  </button>
                </span>
              </div>
              {this.state.store_item_options && this.state.store_item_options.length ? (
                <div className="card-body">
                  {this.state.store_item_options.map((item, i) => {
                    return (
                      <div
                        className="card border m-0"
                        key={i}
                        style={{ background: '#ffe' }}
                      >
                        <div
                          className="card-header"
                          style={{ padding: 20, borderBottom: '1px solid #ddd' }}
                        >
                          <h5 className="float-left card-title">Option {i + 1}#</h5>
                          <span className="float-right">
                            <button
                              disabled={this.state.readOnly}
                              className="btn btn-danger btn-sm"
                              onClick={() => this.removeItemOption(i)}
                            >
                              Remove
                            </button>
                          </span>
                        </div>
                        <div className="card-body row">
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Name in English</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name_en"
                                  placeholder="Name in English"
                                  onChange={(event) => this.handleItemOptionChange(event, i)}
                                  value={item.name_en}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Name in Arabic</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name_ar"
                                  placeholder="Name in English"
                                  onChange={(event) => this.handleItemOptionChange(event, i)}
                                  value={item.name_ar}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Stock Enable</label>
                              <div className="col-sm-9">
                                <select
                                  name="is_stock_enable"
                                  className="form-control"
                                  onChange={(event) => this.handleItemOptionChange(event, i)}
                                  value={item.is_stock_enable}
                                >
                                  <option value="1">Yes</option>
                                  <option value="0"> No </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Stock limit</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="stock_limit"
                                  id="stock_limit"
                                  placeholder="stock limit greater than 0"
                                  onChange={(event) => this.handleItemOptionChange(event, i)}
                                  value={item.stock_limit}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Price</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="price"
                                  id="price"
                                  placeholder="Price"
                                  onChange={(event) => this.handleItemOptionChange(event, i)}
                                  value={item.price}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              ) : null}
            </div>
          )}

          <div className="row float-right p-3">
            <Button
              disabled={this.state.readOnly || this.state.isData}
              onClick={this.onSaveData}
              startIcon={<i className="icofont icofont-save"></i>}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductSoretAdd
